import { render, staticRenderFns } from "./AdminMessageHome.vue?vue&type=template&id=32587218&scoped=true"
import script from "./AdminMessageHome.vue?vue&type=script&lang=js"
export * from "./AdminMessageHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32587218",
  null
  
)

export default component.exports